import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from '../models';
import { UserService } from '../services';

@Component({
  selector: 'layout-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {
  public homeMenu;
  public systemSettingMenu;
  public userMenu;
  public leadMenu;
  public reportMenu;
  public UserNameMenu;
  public roleName;
  currentUser: any = {}
  showUser = false
  constructor(
    private router: Router,
    private userService: UserService
  ) {
    this.roleName = ''
  }

  // currentUser: User;

  setActive(menu, className) {
    if (menu == "user") {
      if (className == undefined || className == "") {
        this.userMenu = "open";
      }
      else {
        this.userMenu = "";
      }
      this.systemSettingMenu = "";
      this.leadMenu = "";
      this.UserNameMenu = "";
    }
    else if (menu == "systemSetting") {
      this.userMenu = "";
      if (className == undefined || className == "") {
        this.systemSettingMenu = "open";
      }
      else {
        this.systemSettingMenu = "";
      }

      this.leadMenu = "";
      this.UserNameMenu = "";
    }
    else if (menu == "lead") {
      this.userMenu = "";
      this.reportMenu = "";
      this.systemSettingMenu = "";
      if (className == undefined || className == "") {
        this.leadMenu = "open";
      }
      else {
        this.leadMenu = "";
      }
      this.UserNameMenu = "";
    } 
     else if (menu == "reports") {
      this.userMenu = "";
       this.leadMenu = "";
      this.systemSettingMenu = "";
      if (className == undefined || className == "") {
        this.reportMenu = "open";
      }
      else {
        this.reportMenu = "";
      }
      this.UserNameMenu = "";
    } 
    
    else if (menu == "home") {
      this.userMenu = "";
      this.systemSettingMenu = "";
      this.leadMenu = "";
      this.UserNameMenu = "";
    }
    else if (menu == "userName") {
      this.userMenu = "";
      this.systemSettingMenu = "";
      this.leadMenu = "";
      if (className == undefined || className == "") {
        this.UserNameMenu = "open";
      }
      else {
        this.UserNameMenu = "";
      }

    }
  }

  ngOnInit() {
    this.userService.currentUser.subscribe(
      (userData): any => {
        this.currentUser = userData;
        var tempuser = this.isEmpty(this.currentUser)
        if (tempuser == false) {
          this.roleName = this.currentUser["roles"]["0"]["designationId"]
        }
        this.showMenu()

      }
    )
  }
  showMenu() {
    if (this.currentUser.roles) {
      if (this.currentUser.roles[0].designationId == 'Admin') {
        this.showUser = true
      } else {
        this.showUser = false
      }

    }
  }

  isEmpty(obj) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop))
        return false;
    }
    return JSON.stringify(obj) === JSON.stringify({});
  }

  logout() {
     this.router.navigateByUrl('/logout')
  }
  reloadPage(){
    
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/layout/header.component.ts